import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H3, H4, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { EmailAddress, ForgotPassword, Href, Password, RememberPassword, SignIn, SignInAccount } from "../../utils/Constant";
import { useState } from "react";
import Swal from "sweetalert2";
import api from "../../utils/api";
import { useEffect } from "react";
// import SocialApp from "./SocialApp";
import { useDispatch } from "react-redux";
import { setLogin } from "../../ReduxToolkit/Reducers/AuthSlice";


const Login = () => {
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState("9876543210");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
  
    const dispatch = useDispatch();

//     const SimpleLoginHandle = async (event: React.FormEvent<HTMLFormElement>) => {
//       event.preventDefault();
//       if (!email || !password) {
//         Swal.fire({
//           title: "Error",
//           text: "Please enter email and password",
//           icon: "error",
//           confirmButtonText: "OK"
//         });
//       }
//       try {
//         const response = await api.post("/api/Auth/StaffLogin", {
//           phoneNumber: email,
//           password: password
//         });

//         console.log(response);
//         const data = response.data;
//         if (response.status === 200 && data.token !== null && data.token !== undefined) {
//           // localStorage.setItem("login", JSON.stringify(true));
//           // localStorage.setItem("user", JSON.stringify(data));
//           // localStorage.setItem("token", JSON.stringify(data.token));
//           dispatch(
//            setLogin({
//            token: data.token,
//              user: data,
//                })
//                  );

//           Swal.fire({
//   title: "Success",
//   text: "Login successful!",
//   icon: "success",
// }).then(() => {
//   navigate("/dashboard/default");
// });

          
//         } else {
//           Swal.fire("Error", data.status || "Invalid credentials", "error");
//         }
//       } catch (error) {
//         Swal.fire("Error", "Something went wrong!", "error");
//       }
//     };


const SimpleLoginHandle = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Validation
  if (!email || !password) {
    Swal.fire({
      title: "Error",
      text: "Please enter mobile number and password",
      icon: "error",
      confirmButtonText: "OK"
    });
    return; // Important: stop execution
  }

  try {
    const response = await api.post("/api/Auth/StaffLogin", {
      phoneNumber: email.trim(),
      password: password.trim(),
    });

    const data = response.data;
    console.log("Login Response:", data); // Debug log

    // Check for successful login
    if (response.status === 200 && data.status === "Login Successful" && data.token) {
      
      // Dispatch to Redux
      dispatch(setLogin({ 
        token: data.token, 
        user: data 
      }));

      // Show success message
      await Swal.fire({
        title: "Success",
        text: "Login successful!",
        icon: "success",
        confirmButtonText: "OK"
      });

      // Navigate after user clicks OK
      navigate("/dashboard/default");

    } else {
      Swal.fire({
        title: "Error",
        text: data.status || "Invalid credentials",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  } catch (error: any) {
    console.error("Login Error:", error);
    
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Something went wrong!",
      icon: "error",
      confirmButtonText: "OK"
    });
  }
};



  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to={Href} style={{ backgroundColor: "black", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)", padding: "10px", borderRadius: "8px" }}>
                  <Image 
                  className="img-fluid for-light" 
                  src={dynamicImage("logo/logo_dark.png")} 
                  alt="looginpage" 
                  style={{ width: "200px", height: "150px" }} 
                  />
                  <Image 
                  className="img-fluid for-dark" 
                  src={dynamicImage("logo/logo_dark.png")} 
                  alt="looginpage" 
                  style={{ width: "200px", height: "150px" }} 
                  />
                </Link>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={(e) => SimpleLoginHandle(e)} >
                  <H3>{SignInAccount}</H3>
                  <P>{"Enter your email & password to login"}</P>
                  <FormGroup>
                    <Label className="col-form-label">Mobile No.</Label>
                    <Input type="text" required placeholder="9876543210" value={email} name="email" onChange={(event) => setEmail(event.target.value)}  />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Input type={show ? "text" : "password"} placeholder="*********"  onChange={(event) => setPassword(event.target.value)} value={password} name="password"/>
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title">
                    <div className="checkbox p-0">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" htmlFor="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    {/* <Link to={`${process.env.PUBLIC_URL}/authentication/forget_password`}  >
                      {ForgotPassword}
                    </Link> */}
                    <div className="text-end mt-3">
                      <Btn color="primary" block  className="w-100" >
                        {SignIn}
                      </Btn>
                    </div>
                  </FormGroup>
                  {/* <H4 className="text-muted mt-4 or">{SignInWith}</H4>
                  <SocialApp />
                  <P className="mt-4 mb-0 text-center">
                    {DoNotAccount}
                    <Link className="ms-2" to={`${process.env.PUBLIC_URL}/authentication/register_simple`} >
                      {CreateAccount}
                    </Link>
                  </P> */}
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
